// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectMilestones-wrap-JQWbq {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --teal: #0f766e;
  --green: #14804a;
  --amber: #9a6700;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  margin-top: 18px;
}

.ProjectMilestones-loading-C46uW {
  padding: 28px;
  text-align: center;
  color: var(--muted);
  font-size: 14px;
}

/* ---- escrow summary card ---- */

.ProjectMilestones-escrowCard-Q211J {
  background: -webkit-gradient(linear, left top, left bottom, from(#f4fbf7), to(#ffffff));
  background: linear-gradient(180deg, #f4fbf7 0%, #ffffff 100%);
  border: 1px solid #cdeadb;
  border-radius: 16px;
  padding: 20px 22px;
  margin-bottom: 18px;
}

.ProjectMilestones-escrowTitle-GBXnE {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--green);
  margin: 0 0 16px;
}

.ProjectMilestones-escrowTitle-GBXnE svg { width: 18px; height: 18px; }

.ProjectMilestones-escrowGrid-xgbRl {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.ProjectMilestones-escrowStat-gKlDW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 12px;
}

.ProjectMilestones-escrowNum-aMsPO { font-size: 20px; font-weight: 800; color: var(--ink); letter-spacing: -0.01em; }

.ProjectMilestones-escrowReleased-EjLC4 { color: var(--green); }

.ProjectMilestones-escrowLabel-y2nS7 { font-size: 12px; font-weight: 600; color: var(--muted); }

.ProjectMilestones-escrowBreak-yotGD {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #cdeadb;
}

.ProjectMilestones-escrowBreakRow-MvFPH {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  font-size: 13px;
  color: var(--muted);
}

.ProjectMilestones-escrowBreakRow-MvFPH strong { color: var(--ink); font-weight: 700; }

.ProjectMilestones-escrowNote-hBjaR {
  margin: 12px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #2c5740;
}

/* ---- schedule card ---- */

.ProjectMilestones-card-u0S3l {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 20px 22px;
  -webkit-box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);
          box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);
}

.ProjectMilestones-cardTitle-imrey {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 800;
  margin: 0 0 16px;
  color: var(--ink);
}

.ProjectMilestones-cardTitle-imrey svg { width: 16px; height: 16px; color: var(--red); }

.ProjectMilestones-emptyText-wifxm { font-size: 14px; color: var(--muted); margin: 0; }

.ProjectMilestones-msList-qFPV9 { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 12px; }

.ProjectMilestones-msRow-kCi7J {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px 16px;
  background: #fff;
  -webkit-transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
}

.ProjectMilestones-msRowOpen-Qc1C3 {
  border-color: #f3c6c8;
  -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.08);
          box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.08);
}

.ProjectMilestones-msMain-Tk8l_ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 14px;
}

.ProjectMilestones-msIndex-tC3f6 {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--bg);
  border: 1px solid var(--line);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: var(--muted);
}

.ProjectMilestones-msInfo-RgymL { -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; min-width: 0; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 4px; }

.ProjectMilestones-msName-eUs9v {
  font-size: 15px;
  font-weight: 700;
  color: var(--ink);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.ProjectMilestones-msTag-CUzVD {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--teal);
  background: #e6f4f2;
  border-radius: 999px;
  padding: 2px 8px;
}

.ProjectMilestones-msDesc-LOXjv { font-size: 13px; color: var(--muted); line-height: 1.4; }

.ProjectMilestones-msTimeline-cq8RF { font-size: 12px; color: var(--muted); }

.ProjectMilestones-msRight-kFvrl {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 6px;
}

.ProjectMilestones-msAmt-aRCSY { font-size: 16px; font-weight: 800; color: var(--ink); }

.ProjectMilestones-statusPill-yl4P5 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-radius: 999px;
  padding: 4px 10px;
  background: var(--bg);
  color: var(--muted);
  border: 1px solid var(--line);
  white-space: nowrap;
}

.ProjectMilestones-st_pending-L_4XP { background: #f3f4f6; color: #6b7280; }

.ProjectMilestones-st_ready-vwvSm { background: #eef5ff; color: #2563eb; border-color: #d4e4ff; }

.ProjectMilestones-st_in_progress-RQDtb { background: #fff5e6; color: var(--amber); border-color: #f5e2bf; }

.ProjectMilestones-st_submitted_for_review-RXFVo { background: #f0eaff; color: #6d28d9; border-color: #e0d6ff; }

.ProjectMilestones-st_approved-RUpdC { background: #e9f6ef; color: var(--green); border-color: #c8e9d6; }

.ProjectMilestones-st_paid-EyC2Y { background: #e9f6ef; color: var(--green); border-color: #c8e9d6; }

.ProjectMilestones-st_disputed-VF5yn { background: #fdeaea; color: var(--red-d); border-color: #f5cccd; }

.ProjectMilestones-st_cancelled-WvDP_ { background: #f3f4f6; color: #9ca3af; }

/* ---- per-row actions ---- */

.ProjectMilestones-msActions-pN47z {
  margin-top: 14px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 10px;
}

.ProjectMilestones-msHint-IXrKh {
  margin: 12px 0 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 7px;
  font-size: 13px;
  color: var(--muted);
}

.ProjectMilestones-msHint-IXrKh svg { width: 16px; height: 16px; }

.ProjectMilestones-msHintDone-jWCHi {
  margin: 12px 0 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 600;
  color: var(--green);
}

.ProjectMilestones-msHintDone-jWCHi svg { width: 16px; height: 16px; }

/* ---- client approval panel ---- */

.ProjectMilestones-approveBox-aPoGY {
  margin-top: 16px;
  padding: 16px;
  border-radius: 12px;
  background: var(--bg);
  border: 1px solid var(--line);
}

.ProjectMilestones-approveTitle-WuJOA {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 800;
  margin: 0 0 8px;
  color: var(--ink);
}

.ProjectMilestones-approveTitle-WuJOA svg { width: 16px; height: 16px; color: var(--red); }

.ProjectMilestones-approveBody-yvwvd { font-size: 13px; line-height: 1.5; color: var(--muted); margin: 0 0 14px; }

.ProjectMilestones-approveBody-yvwvd strong { color: var(--ink); }

.ProjectMilestones-consentRow-Vif04 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.ProjectMilestones-consentRow-Vif04 input { margin-top: 3px; -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; }

.ProjectMilestones-consentText-nzw7a { font-size: 13px; line-height: 1.45; color: var(--ink); }

.ProjectMilestones-approveActions-WGSho {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
}

.ProjectMilestones-approveFootRow-Lq4Ol {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  margin-top: 12px;
}

.ProjectMilestones-otpRow-sgbNi { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 10px; -webkit-box-align: end; -ms-flex-align: end; align-items: flex-end; -ms-flex-wrap: wrap; flex-wrap: wrap; margin-top: 10px; }

.ProjectMilestones-fieldLabel-oP5De { font-size: 12px; font-weight: 700; color: var(--muted); display: block; margin-bottom: 6px; }

.ProjectMilestones-input-Bd2ys {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  color: var(--ink);
  background: #fff;
}

.ProjectMilestones-input-Bd2ys:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }

.ProjectMilestones-codeInput-leXig { letter-spacing: 0.3em; font-weight: 700; max-width: 200px; }

.ProjectMilestones-scrollNote-KBDd6 { font-size: 12px; color: var(--muted); margin: 12px 0 0; line-height: 1.45; }

/* ---- buttons ---- */

.ProjectMilestones-btn-Kipjk {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border: none;
  background: var(--red);
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.ProjectMilestones-btn-Kipjk:hover { background: var(--red-d); }

.ProjectMilestones-btn-Kipjk:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectMilestones-btnGhost-xOHFl {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--ink);
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
}

.ProjectMilestones-btnGhost-xOHFl:hover { border-color: #d4d7db; }

.ProjectMilestones-btnGhost-xOHFl:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectMilestones-linkBtn-rrdQp {
  border: none;
  background: none;
  color: var(--red);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
}

.ProjectMilestones-linkBtn-rrdQp:disabled { opacity: 0.5; cursor: not-allowed; }

/* ---- alerts ---- */

.ProjectMilestones-alertErr-UTt4e {
  background: #fdeaea;
  border: 1px solid #f5cccd;
  color: var(--red-d);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}

.ProjectMilestones-alertNotice-Wf_UA {
  background: #eef5ff;
  border: 1px solid #d4e4ff;
  color: #2563eb;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}

@media (max-width: 640px) {
  .ProjectMilestones-escrowGrid-xgbRl { grid-template-columns: 1fr; }
  .ProjectMilestones-msMain-Tk8l_ { -ms-flex-wrap: wrap; flex-wrap: wrap; }
  .ProjectMilestones-msRight-kFvrl { width: 100%; -webkit-box-orient: horizontal; -webkit-box-direction: normal; -ms-flex-direction: row; flex-direction: row; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; margin-top: 8px; }
  .ProjectMilestones-msActions-pN47z { -webkit-box-pack: stretch; -ms-flex-pack: stretch; justify-content: stretch; }
  .ProjectMilestones-msActions-pN47z .ProjectMilestones-btn-Kipjk { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectMilestones/ProjectMilestones.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,uFAA6D;EAA7D,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,2CAAmB,WAAW,EAAE,YAAY,EAAE;;AAC9C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AACA,qCAAa,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;;AAC5F,0CAAkB,mBAAmB,EAAE;;AACvC,uCAAe,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AACvE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AACA,iDAAyB,iBAAiB,EAAE,gBAAgB,EAAE;;AAC9D;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,yCAAiB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAC/D,qCAAa,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE9D,kCAAU,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,SAAS,EAAE;;AAE5D;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0D;EAA1D,kEAA0D;EAA1D,0DAA0D;EAA1D,yFAA0D;AAC5D;;AACA;EACE,qBAAqB;EACrB,qDAA6C;UAA7C,6CAA6C;AAC/C;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;AACX;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA,kCAAU,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE,YAAY,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AACzF;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AACA,kCAAU,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAClE,sCAAc,eAAe,EAAE,mBAAmB,EAAE;;AAEpD;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,QAAQ;AACV;;AACA,iCAAS,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAE/D;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AACA,sCAAc,mBAAmB,EAAE,cAAc,EAAE;;AACnD,oCAAY,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AACxE,0CAAkB,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AACnF,mDAA2B,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AACvF,uCAAe,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAChF,mCAAW,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAC5E,uCAAe,mBAAmB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAChF,wCAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD,8BAA8B;;AAE9B;EACE,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;AACX;;AACA;EACE,gBAAgB;EAChB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AACA,sCAAc,WAAW,EAAE,YAAY,EAAE;;AACzC;EACE,gBAAgB;EAChB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA,0CAAkB,WAAW,EAAE,YAAY,EAAE;;AAE7C,oCAAoC;;AAEpC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AACA,4CAAoB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAClE,uCAAe,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACzF,8CAAsB,iBAAiB,EAAE;;AAEzC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AACA,4CAAoB,eAAe,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AACrD,uCAAe,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;;AAEtE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,kCAAU,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,SAAS,EAAE,sBAAqB,EAArB,mBAAqB,EAArB,qBAAqB,EAAE,mBAAe,EAAf,eAAe,EAAE,gBAAgB,EAAE;;AAC9F,sCAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE1G;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AACA,uCAAe,aAAa,EAAE,wBAAwB,EAAE,qDAA6C,EAA7C,6CAA6C,EAAE;;AACvG,qCAAa,qBAAqB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAExE,sCAAc,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEzF,sBAAsB;;AAEtB;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AACA,qCAAa,wBAAwB,EAAE;;AACvC,wCAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AACA,0CAAkB,qBAAqB,EAAE;;AACzC,6CAAqB,YAAY,EAAE,mBAAmB,EAAE;;AAExD;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;;AACA,4CAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD,qBAAqB;;AAErB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAc,0BAA0B,EAAE;EAC1C,kCAAU,mBAAe,EAAf,eAAe,EAAE;EAC3B,mCAAW,WAAW,EAAE,8BAAmB,EAAnB,6BAAmB,EAAnB,uBAAmB,EAAnB,mBAAmB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,eAAe,EAAE;EACnH,qCAAa,yBAAwB,EAAxB,sBAAwB,EAAxB,wBAAwB,EAAE;EACvC,kEAAkB,WAAW,EAAE;AACjC","sourcesContent":[".wrap {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --teal: #0f766e;\n  --green: #14804a;\n  --amber: #9a6700;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  margin-top: 18px;\n}\n\n.loading {\n  padding: 28px;\n  text-align: center;\n  color: var(--muted);\n  font-size: 14px;\n}\n\n/* ---- escrow summary card ---- */\n\n.escrowCard {\n  background: linear-gradient(180deg, #f4fbf7 0%, #ffffff 100%);\n  border: 1px solid #cdeadb;\n  border-radius: 16px;\n  padding: 20px 22px;\n  margin-bottom: 18px;\n}\n.escrowTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--green);\n  margin: 0 0 16px;\n}\n.escrowTitle svg { width: 18px; height: 18px; }\n.escrowGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n.escrowStat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n}\n.escrowNum { font-size: 20px; font-weight: 800; color: var(--ink); letter-spacing: -0.01em; }\n.escrowReleased { color: var(--green); }\n.escrowLabel { font-size: 12px; font-weight: 600; color: var(--muted); }\n.escrowBreak {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px dashed #cdeadb;\n}\n.escrowBreakRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--muted);\n}\n.escrowBreakRow strong { color: var(--ink); font-weight: 700; }\n.escrowNote {\n  margin: 12px 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #2c5740;\n}\n\n/* ---- schedule card ---- */\n\n.card {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 20px 22px;\n  box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);\n}\n.cardTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 800;\n  margin: 0 0 16px;\n  color: var(--ink);\n}\n.cardTitle svg { width: 16px; height: 16px; color: var(--red); }\n.emptyText { font-size: 14px; color: var(--muted); margin: 0; }\n\n.msList { display: flex; flex-direction: column; gap: 12px; }\n\n.msRow {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 14px 16px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.msRowOpen {\n  border-color: #f3c6c8;\n  box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.08);\n}\n\n.msMain {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n.msIndex {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--muted);\n}\n.msInfo { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 4px; }\n.msName {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ink);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.msTag {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--teal);\n  background: #e6f4f2;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n.msDesc { font-size: 13px; color: var(--muted); line-height: 1.4; }\n.msTimeline { font-size: 12px; color: var(--muted); }\n\n.msRight {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n.msAmt { font-size: 16px; font-weight: 800; color: var(--ink); }\n\n.statusPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  border-radius: 999px;\n  padding: 4px 10px;\n  background: var(--bg);\n  color: var(--muted);\n  border: 1px solid var(--line);\n  white-space: nowrap;\n}\n.st_pending { background: #f3f4f6; color: #6b7280; }\n.st_ready { background: #eef5ff; color: #2563eb; border-color: #d4e4ff; }\n.st_in_progress { background: #fff5e6; color: var(--amber); border-color: #f5e2bf; }\n.st_submitted_for_review { background: #f0eaff; color: #6d28d9; border-color: #e0d6ff; }\n.st_approved { background: #e9f6ef; color: var(--green); border-color: #c8e9d6; }\n.st_paid { background: #e9f6ef; color: var(--green); border-color: #c8e9d6; }\n.st_disputed { background: #fdeaea; color: var(--red-d); border-color: #f5cccd; }\n.st_cancelled { background: #f3f4f6; color: #9ca3af; }\n\n/* ---- per-row actions ---- */\n\n.msActions {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.msHint {\n  margin: 12px 0 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  color: var(--muted);\n}\n.msHint svg { width: 16px; height: 16px; }\n.msHintDone {\n  margin: 12px 0 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--green);\n}\n.msHintDone svg { width: 16px; height: 16px; }\n\n/* ---- client approval panel ---- */\n\n.approveBox {\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: 12px;\n  background: var(--bg);\n  border: 1px solid var(--line);\n}\n.approveTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  color: var(--ink);\n}\n.approveTitle svg { width: 16px; height: 16px; color: var(--red); }\n.approveBody { font-size: 13px; line-height: 1.5; color: var(--muted); margin: 0 0 14px; }\n.approveBody strong { color: var(--ink); }\n\n.consentRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.consentRow input { margin-top: 3px; flex: 0 0 auto; }\n.consentText { font-size: 13px; line-height: 1.45; color: var(--ink); }\n\n.approveActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 6px;\n}\n.approveFootRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.otpRow { display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap; margin-top: 10px; }\n.fieldLabel { font-size: 12px; font-weight: 700; color: var(--muted); display: block; margin-bottom: 6px; }\n\n.input {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--ink);\n  background: #fff;\n}\n.input:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }\n.codeInput { letter-spacing: 0.3em; font-weight: 700; max-width: 200px; }\n\n.scrollNote { font-size: 12px; color: var(--muted); margin: 12px 0 0; line-height: 1.45; }\n\n/* ---- buttons ---- */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: var(--red);\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.btn:hover { background: var(--red-d); }\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.btnGhost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--ink);\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n}\n.btnGhost:hover { border-color: #d4d7db; }\n.btnGhost:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.linkBtn {\n  border: none;\n  background: none;\n  color: var(--red);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n.linkBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ---- alerts ---- */\n\n.alertErr {\n  background: #fdeaea;\n  border: 1px solid #f5cccd;\n  color: var(--red-d);\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n.alertNotice {\n  background: #eef5ff;\n  border: 1px solid #d4e4ff;\n  color: #2563eb;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n\n@media (max-width: 640px) {\n  .escrowGrid { grid-template-columns: 1fr; }\n  .msMain { flex-wrap: wrap; }\n  .msRight { width: 100%; flex-direction: row; align-items: center; justify-content: space-between; margin-top: 8px; }\n  .msActions { justify-content: stretch; }\n  .msActions .btn { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ProjectMilestones-wrap-JQWbq`,
	"loading": `ProjectMilestones-loading-C46uW`,
	"escrowCard": `ProjectMilestones-escrowCard-Q211J`,
	"escrowTitle": `ProjectMilestones-escrowTitle-GBXnE`,
	"escrowGrid": `ProjectMilestones-escrowGrid-xgbRl`,
	"escrowStat": `ProjectMilestones-escrowStat-gKlDW`,
	"escrowNum": `ProjectMilestones-escrowNum-aMsPO`,
	"escrowReleased": `ProjectMilestones-escrowReleased-EjLC4`,
	"escrowLabel": `ProjectMilestones-escrowLabel-y2nS7`,
	"escrowBreak": `ProjectMilestones-escrowBreak-yotGD`,
	"escrowBreakRow": `ProjectMilestones-escrowBreakRow-MvFPH`,
	"escrowNote": `ProjectMilestones-escrowNote-hBjaR`,
	"card": `ProjectMilestones-card-u0S3l`,
	"cardTitle": `ProjectMilestones-cardTitle-imrey`,
	"emptyText": `ProjectMilestones-emptyText-wifxm`,
	"msList": `ProjectMilestones-msList-qFPV9`,
	"msRow": `ProjectMilestones-msRow-kCi7J`,
	"msRowOpen": `ProjectMilestones-msRowOpen-Qc1C3`,
	"msMain": `ProjectMilestones-msMain-Tk8l_`,
	"msIndex": `ProjectMilestones-msIndex-tC3f6`,
	"msInfo": `ProjectMilestones-msInfo-RgymL`,
	"msName": `ProjectMilestones-msName-eUs9v`,
	"msTag": `ProjectMilestones-msTag-CUzVD`,
	"msDesc": `ProjectMilestones-msDesc-LOXjv`,
	"msTimeline": `ProjectMilestones-msTimeline-cq8RF`,
	"msRight": `ProjectMilestones-msRight-kFvrl`,
	"msAmt": `ProjectMilestones-msAmt-aRCSY`,
	"statusPill": `ProjectMilestones-statusPill-yl4P5`,
	"st_pending": `ProjectMilestones-st_pending-L_4XP`,
	"st_ready": `ProjectMilestones-st_ready-vwvSm`,
	"st_in_progress": `ProjectMilestones-st_in_progress-RQDtb`,
	"st_submitted_for_review": `ProjectMilestones-st_submitted_for_review-RXFVo`,
	"st_approved": `ProjectMilestones-st_approved-RUpdC`,
	"st_paid": `ProjectMilestones-st_paid-EyC2Y`,
	"st_disputed": `ProjectMilestones-st_disputed-VF5yn`,
	"st_cancelled": `ProjectMilestones-st_cancelled-WvDP_`,
	"msActions": `ProjectMilestones-msActions-pN47z`,
	"msHint": `ProjectMilestones-msHint-IXrKh`,
	"msHintDone": `ProjectMilestones-msHintDone-jWCHi`,
	"approveBox": `ProjectMilestones-approveBox-aPoGY`,
	"approveTitle": `ProjectMilestones-approveTitle-WuJOA`,
	"approveBody": `ProjectMilestones-approveBody-yvwvd`,
	"consentRow": `ProjectMilestones-consentRow-Vif04`,
	"consentText": `ProjectMilestones-consentText-nzw7a`,
	"approveActions": `ProjectMilestones-approveActions-WGSho`,
	"approveFootRow": `ProjectMilestones-approveFootRow-Lq4Ol`,
	"otpRow": `ProjectMilestones-otpRow-sgbNi`,
	"fieldLabel": `ProjectMilestones-fieldLabel-oP5De`,
	"input": `ProjectMilestones-input-Bd2ys`,
	"codeInput": `ProjectMilestones-codeInput-leXig`,
	"scrollNote": `ProjectMilestones-scrollNote-KBDd6`,
	"btn": `ProjectMilestones-btn-Kipjk`,
	"btnGhost": `ProjectMilestones-btnGhost-xOHFl`,
	"linkBtn": `ProjectMilestones-linkBtn-rrdQp`,
	"alertErr": `ProjectMilestones-alertErr-UTt4e`,
	"alertNotice": `ProjectMilestones-alertNotice-Wf_UA`
};
module.exports = ___CSS_LOADER_EXPORT___;
